import { Eye, Target, Heart, Shield, Users, FileText } from "lucide-react";

const VALUES = [
  { icon: Heart, title: "Equite", desc: "Garantir un acces egal au savoir et aux technologies pour tous, independamment de l'origine sociale." },
  { icon: Users, title: "Inclusion", desc: "Placer les publics vulnerables au coeur de nos actions et valoriser la diversite comme richesse." },
  { icon: Target, title: "Innovation", desc: "Exploiter le potentiel des technologies emergentes, notamment l'IA, au service de l'education." },
  { icon: Shield, title: "Transparence", desc: "Rendre compte de nos actions et de l'utilisation des ressources avec rigueur et honnetete." },
];

export default function MissionPage() {
  return (
    <div data-testid="mission-page" className="pt-24">
      {/* Hero */}
      <section className="py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <p className="font-body text-xs md:text-sm font-medium tracking-[0.2em] uppercase text-blue-400 mb-6">
            Notre Mission
          </p>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-slate-50 mb-8 max-w-4xl leading-[1.1]">
            Reduire les inegalites par l'education, le numerique et l'IA
          </h1>
          <p className="font-body text-base md:text-lg font-light leading-relaxed text-slate-300 max-w-3xl">
            Depuis 2018, EDUCPEOPLE.org agit pour promouvoir l'acces equitable au savoir et aux competences numeriques, afin de favoriser la reussite educative et l'insertion professionnelle des publics vulnerables.
          </p>
        </div>
      </section>

      <div className="section-divider" />

      {/* Who We Are */}
      <section className="py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <p className="font-body text-xs font-medium tracking-[0.2em] uppercase text-blue-400 mb-4">
              Qui sommes-nous
            </p>
            <h2 className="font-heading text-3xl md:text-4xl font-light text-slate-50 mb-6">
              Une association engagee pour l'education du peuple
            </h2>
            <div className="space-y-4 font-body text-base text-slate-300 leading-relaxed">
              <p>
                EDUCPEOPLE.org, Education du Peuple, est une association a but non lucratif creee le 11 mai 2018, basee a Chaville (92370). Elle appartient au champ de l'Economie Sociale et Solidaire (ESS).
              </p>
              <p>
                Notre association a pour objet de promouvoir l'acces equitable au savoir, aux competences numeriques et aux technologies emergentes, notamment l'intelligence artificielle, afin de favoriser la reussite educative, l'inclusion sociale et l'insertion professionnelle des publics vulnerables.
              </p>
            </div>
          </div>
          <div className="relative">
            <div className="rounded-3xl overflow-hidden border border-white/10">
              <img
                src="https://images.unsplash.com/photo-1758270705518-b61b40527e76?w=800&q=80"
                alt="Equipe EDUCPEOPLE"
                className="w-full h-80 object-cover opacity-80"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 w-32 h-32 rounded-2xl bg-blue-500/10 border border-blue-500/30 flex items-center justify-center">
              <div className="text-center">
                <div className="font-body text-3xl font-bold text-blue-400">8+</div>
                <div className="font-body text-xs text-blue-400/80 uppercase tracking-wider">ans d'action</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="section-divider" />

      {/* Vision & Mission */}
      <section className="py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="bg-slate-900/50 border border-white/10 rounded-3xl p-8 md:p-12">
            <div className="w-12 h-12 rounded-xl bg-blue-500/20 flex items-center justify-center mb-6">
              <Eye className="w-6 h-6 text-blue-400" />
            </div>
            <h3 className="font-heading text-2xl md:text-3xl font-light text-slate-50 mb-4">Notre Vision</h3>
            <p className="font-body text-base text-slate-300 leading-relaxed">
              Un monde ou chaque individu, quelle que soit son origine, a acces aux savoirs et aux outils numeriques necessaires pour construire son avenir. L'education pour tous, augmentee par l'innovation.
            </p>
          </div>
          <div className="bg-slate-900/50 border border-white/10 rounded-3xl p-8 md:p-12">
            <div className="w-12 h-12 rounded-xl bg-blue-500/20 flex items-center justify-center mb-6">
              <Target className="w-6 h-6 text-blue-400" />
            </div>
            <h3 className="font-heading text-2xl md:text-3xl font-light text-slate-50 mb-4">Notre Mission</h3>
            <p className="font-body text-base text-slate-300 leading-relaxed">
              Accompagner les publics vulnerables vers la reussite educative, l'inclusion numerique et l'employabilite, en deployant des programmes innovants qui combinent accompagnement humain et technologies emergentes.
            </p>
          </div>
        </div>
      </section>

      <div className="section-divider" />

      {/* Values */}
      <section className="py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="mb-16">
            <p className="font-body text-xs font-medium tracking-[0.2em] uppercase text-blue-400 mb-4">Nos Valeurs</p>
            <h2 className="font-heading text-4xl md:text-5xl font-light text-slate-50">Ce qui nous guide</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {VALUES.map((val) => (
              <div
                key={val.title}
                data-testid={`value-${val.title.toLowerCase()}`}
                className="bg-slate-900/50 border border-white/10 rounded-2xl p-6 hover:border-blue-500/30 transition-colors duration-300"
              >
                <div className="w-10 h-10 rounded-lg bg-blue-500/20 flex items-center justify-center mb-4">
                  <val.icon className="w-5 h-5 text-blue-400" />
                </div>
                <h4 className="font-heading text-xl font-medium text-slate-50 mb-2">{val.title}</h4>
                <p className="font-body text-sm text-slate-400 leading-relaxed">{val.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div className="section-divider" />

      {/* Governance & Transparency */}
      <section className="py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-2 gap-16">
          <div>
            <div className="w-12 h-12 rounded-xl bg-blue-500/20 flex items-center justify-center mb-6">
              <Users className="w-6 h-6 text-blue-400" />
            </div>
            <h3 className="font-heading text-2xl md:text-3xl font-light text-slate-50 mb-4">Gouvernance</h3>
            <p className="font-body text-base text-slate-300 leading-relaxed mb-6">
              EDUCPEOPLE est gouvernee par un bureau compose de membres benevoles engages dans l'education et l'innovation sociale. Les decisions sont prises de maniere collegiale lors d'assemblees generales annuelles.
            </p>
            <ul className="space-y-3">
              {["Bureau executif benevole", "Assemblee generale annuelle", "Comite de pilotage des programmes", "Conseil scientifique consultatif"].map((item) => (
                <li key={item} className="flex items-center gap-3">
                  <div className="w-1.5 h-1.5 rounded-full bg-blue-500" />
                  <span className="font-body text-sm text-slate-300">{item}</span>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <div className="w-12 h-12 rounded-xl bg-blue-500/20 flex items-center justify-center mb-6">
              <FileText className="w-6 h-6 text-blue-400" />
            </div>
            <h3 className="font-heading text-2xl md:text-3xl font-light text-slate-50 mb-4">Transparence financiere</h3>
            <p className="font-body text-base text-slate-300 leading-relaxed mb-6">
              Engagee dans une demarche de transparence totale, EDUCPEOPLE publie chaque annee un rapport d'activite et un bilan financier detaille, accessibles a tous nos donateurs et partenaires.
            </p>
            <div className="bg-slate-900/50 border border-white/10 rounded-2xl p-6">
              <p className="font-body text-sm text-slate-400 mb-2">Informations legales</p>
              <ul className="space-y-2">
                <li className="font-body text-sm text-slate-300">SIREN : 839 800 851</li>
                <li className="font-body text-sm text-slate-300">SIRET : 839 800 851 00017</li>
                <li className="font-body text-sm text-slate-300">Code NAF : 94.99Z</li>
                <li className="font-body text-sm text-slate-300">Statut : ESS</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
